$shm_projects_card $mol_view
	project_id \
	sub /
		<= Head $mol_view
			sub /
				<= Project_title $mol_link
					arg <= project_arg *
					sub / <= project_title \
				<= Project_version $mol_view
					sub / <= project_version \
		<= Channels $mol_view
			sub /
				<= Prerelease $mol_view
					sub /
						<= Prerelease_label $mol_view
							sub / \Пререлиз
						<= Prerelease_link $mol_link
							arg <= project_prerelease_arg *
							sub / <= project_prerelease \
				<= Release $mol_view
					sub /
						<= Release_label $mol_view
							sub / \Релиз
						<= project_release \
		<= Updated $mol_view
			sub /
				<= Updated_label $mol_view
					sub / \Обновлён
				<= project_version_date \
